export const GEN_AI_TEXT_TO_WF = 'gen-ai-text-to-wf';
export const GEN_AI_TEXT_TO_WF_EDIT = 'gen-ai-text-to-wf-edit';
